import { UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import MembershipStore from "../MembershipStore";  
import { inject, observer } from "mobx-react";
import React from "react"; 
import { NavigateFunction } from "react-router-dom";
import { PricingBuilder } from "../../../shared/components";

type Props = {
  membershipStore?: MembershipStore;
  navigate: NavigateFunction;
};

@inject('membershipStore')
@observer
class PricingPage extends React.Component<Props> {
  render(): React.ReactNode {
      return (
          <PricingBuilder
              headerCaption="Membership Pricing"
              itemName={this.props.membershipStore?.detailPage?.name || ''}
              pricingPageData={this.props.membershipStore?.pricingPageData}
              detailPage={this.props.membershipStore?.detailPage}
              descriptionHtml={UtilityMethods.getEditorHtmlContent(
                  this.props.membershipStore?.detailPage?.descriptionEditorRawContent || '',
              )}
          />
      );
  }
}

export default withRouter(PricingPage);
